import { render, staticRenderFns } from "./line-item-accessories.vue?vue&type=template&id=709369e5"
import script from "./line-item-accessories.vue?vue&type=script&lang=js"
export * from "./line-item-accessories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports